<template>
  <settings>
    <div class="py-md-4 my-md-2 px-md-5">
      <div class="p-3 p-md-0" :style="overlayImageClass">
        <div>
          <div class="border-bottom border-light d-inline-flex pb-2 pt-md-4 mt-md-5">
            <p
              v-if="!botUrl"
              :class="size ? 'h3' : 'h4 mb-2'"
              class="text-primary font-weight-normal"
            >
              @koeebox_bot
            </p>
            <a v-if="botUrl" :href="botUrl" target="_blank">
              <p :class="size ? 'h3' : 'h4 mb-2'" class="text-primary font-weight-normal">
                @koeebox_bot
              </p>
            </a>
          </div>
          <div
            class="pt-md-5 mt-4 font-weight-normal botLineHeight"
            :class="size ? 'w-50 h3' : 'w-100 h4'"
          >
            <span>
              {{ $t('support.bot.telegram.description') }}
            </span>
          </div>
          <div class="mt-5 pt-md-5">
            <a v-if="botUrl" :href="botUrl" target="_blank" class="mr-3 mr-md-2">
              <b-img
                height="56"
                width="56"
                :src="telegramIcon"
                rounded="circle"
                alt="telegramIcon"
              ></b-img>
            </a>
            <!-- <a :href="botUrl" target="_blank" class="ml-3 ml-md-5" >
              <b-img height="56" width="56" :src="viberIcon" rounded="circle" alt="viberIcon"></b-img>
            </a> -->
          </div>
        </div>
      </div>
      <b-img v-if="!size" class="w-100" :src="botChatBackgroundMobile" alt="mobileViewChat"></b-img>
    </div>
  </settings>
</template>

<script>
import getBotUrl from '@/api/support/getBotUrl.gql';
import botChatBackground from '@/assets/images/botBackground.png';
import telegramIcon from '@/assets/images/telegram.png';
// import viberIcon from '@/assets/images/viber.png'
import botChatBackgroundMobile from '@/assets/images/botMobile.png';
import { vueWindowSizeMixin } from 'vue-window-size';

export default {
  name: 'BotLinks',
  mixins: [vueWindowSizeMixin],
  data: () => {
    return {};
  },
  apollo: {
    botUrl: {
      query: getBotUrl,
      variables() {
        return {
          lang: this.locale,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).getBotUrl.url || '';
      },
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    overlayImageClass() {
      return {
        height: this.imageHeight,
        background: 'url(' + this.botChatBackground + ')' + 'right top no-repeat',
        'background-size': this.imageHeight,
      };
    },
    size() {
      return this.windowWidth > 768;
    },
    imageHeight() {
      return this.size ? this.windowWidth / 2.33 + 'px' : 'auto';
    },
    botChatBackground() {
      return this.size ? botChatBackground : '';
    },
    botChatBackgroundMobile() {
      return botChatBackgroundMobile;
    },
    telegramIcon() {
      return telegramIcon;
    },
    // viberIcon() {
    //   return viberIcon
    // },
  },
};
</script>
<style lang="scss" scoped>
.botLineHeight {
  line-height: 33.6px;
}
</style>
